import { callFunction } from './functionsClient';

export const searchWords = (payload, getAccessToken) =>
  callFunction('searchwords', payload, getAccessToken);
export const getWordDetail = (payload, getAccessToken) =>
  callFunction('getWordDetail', payload, getAccessToken);
